<svelte:head>
	<link rel='stylesheet' href='/static/articles/vendor/bootstrap/css/bootstrap.min.css'> 
	<script src="/static/articles/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
</svelte:head>

<script>
    import { onMount } from "svelte";
    import { username, password, logincode, InitForm, errorAlertMessage,  login, OnChangeLogin, disabledButton } from "../store.js";
    import { Icon, TabContent, TabPane, Button } from "sveltestrap";
    import { Telegram, List, XLg, CheckLg, ExclamationLg} from "svelte-bootstrap-icons";
    onMount(async () => {
		   await InitForm();	
	  });
</script>

<TabContent>
  <TabPane tabId="Standart" active>
      <span slot="tab"><List/> Войти </span>

      {#if $errorAlertMessage != "" }
        <div class="alert alert-danger col-12" role="alert">
          {$errorAlertMessage}
        </div>
      {/if}

      <div class="form-group">
        <label for="username">Имя пользователя</label>
        <input type="text" id="username" class="form-control" placeholder="Имя пользователя" bind:value={$username} />
      </div> 

      <div class="form-group"> 
          <label for="password"> Пароль </label> 
          <input type="password" id="password" class="form-control" placeholder="Пароль" bind:value={$password} />  
      </div>
      
      <div class="form-row">
        <div class="py-2">
          <Button outline color="danger" on:click={() => login("ByPassword")}>Войти</Button> 
        </div>
      </div>
    </TabPane >

  <TabPane tabId="ByTelegram">
    <span slot="tab"><Telegram/> Войти через Telegram </span>
        {#if $errorAlertMessage != "" }
          <div class="alert alert-danger col-12" role="alert">
            {$errorAlertMessage}
          </div>
        {/if}

        <div class="form-description">
          <p>Введите имя вашего пользователя и затем затребуйте вход у нашего телеграм бота</p> 
        </div>

        <div class="form-group">
          <label for="registration_username">Имя пользователя</label> 
          <input type="text" id="registration_username"  class="form-control" placeholder="Имя пользователя" bind:value={$username} on:change={OnChangeLogin} >
        </div>

        <div class="bot-form">
          <div class="form-group" style="text-align: center; margin: 5px auto; width: 100%">
            <p>Имя бота в Telegram </p>
            <p style="color: red; font-weight: bold; border: 1px solid red; padding: 2px; border-radius: 3px; font-size: 16px;">@c78by_bot</p> 
          </div>   
        </div>

        <div class="bot-form">
          <div class="form-group">
              <label for="confirmation_code">Код для входа (получить у бота)</label> 
              <input type="text" id="confirmation_code" class="form-control" placeholder="Код входа" 
              bind:value={$logincode}>
          </div>   
        </div>
        <div class="form-row">
          <div class="py-2">
            <Button outline color="danger" on:click={() => login("Telegram")} disabled='{$disabledButton}'>Войти</Button>
          </div>
        </div> 
  </TabPane>
</TabContent>

<style>
  .form-description p {
    font-style: italic;
    font-weight: bold;
    float: left;
    width: 100%;
    padding: 3px;
    text-align: left;
  }
  .form-group label {
    font-weight: bold;
    float: left;
  }
  .form-group>p:first-child {
    font-weight: bold;
    float: left;
    padding: 3px;
  }
  .form-group input {
    border: 1px solid red;
  }
  :global(.nav-link) {
    color: red;
  } 
  :global(.nav-link:hover) {
    color: red;
  }
  .alert-danger {
    color: hsl(330, 100%, 50%); 
    font-weight: bold;
    text-shadow: 0 2px 0 0px hsl(330, 100%, 25%),
             0 3px 2px 0px hsla(330, 100%, 15%, 0.5);
  }
</style>
